import React from "react";
import TokenEngine from "@vp/vp-js-token-engine";
import { PurifiedComponent } from "../../../../components/PurifiedComponent";

interface SpecsAndTemplatesCalloutAnchorLinkProps {
  specsCalloutLink: string;
  designSpecsTabIndex: number;
  productPageTabId: string;
}

export const SpecsAndTemplatesCalloutAnchorLink: React.FC<SpecsAndTemplatesCalloutAnchorLinkProps> = props => {
  const tokenEngine = new TokenEngine();
  const SpecsAndTemplatesCalloutAnchorLink = tokenEngine.replace(props.specsCalloutLink, {
    OpenLink: `<a href="${
      props.designSpecsTabIndex !== undefined && props.designSpecsTabIndex >= 0
        ? `#${props.productPageTabId}`
        : undefined
    }">`,
    CloseLink: "</a>",
  });

  return <PurifiedComponent component="div" content={SpecsAndTemplatesCalloutAnchorLink} />;
};
